export const API_ENDPOINT_URL = process.env.REACT_APP_API_ENDPOINT_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const PUBLIC_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL;
export const IMAGE_STORAGE = process.env.REACT_APP_IMAGE_STORAGE;
export const IMAGE_QUALITY = process.env.REACT_APP_IMAGE_QUALITY || 85;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const GTM_ID = process.env.REACT_APP_GTM_ID;